export const MapTilesIcon = ({
  fill = 'currentColor',
  width = '21',
  height = '21',
  viewBox = '0 0 21 21',
  ...rest
}: React.SVGProps<SVGSVGElement>) => (
  <svg width={width} height={height} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path d="M2.5 4H9.61111V10.125H2.5V4Z" fill={fill} />
    <path d="M11.3889 4H18.5V10.125H11.3889V4Z" fill={fill} />
    <path d="M11.3889 11.875H18.5V18H11.3889V11.875Z" fill={fill} />
    <path d="M2.5 11.875H9.61111V18H2.5V11.875Z" fill={fill} />
  </svg>
)
